import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { apiCheckProblemGroups, apiCreateProblemGroups, apiGetPGHistoryList, apiGetProblemGroupsList, apiGetProblemGroupsPrtnerList, apiPublishProblemGroup, apiRestorePGVersion } from 'services/CropHealth'

export const getProblemGroupsList = createAsyncThunk('CropHealthGlobal/getProblemGroupsList', async ({ partnerId }) => {
    // const response = await apiGetProblemGroupsList()
    // return response.data

    const globalProblemGroup = await apiGetProblemGroupsList()
    const partnerProblemGroup = await apiGetProblemGroupsPrtnerList(partnerId)
    return { globalProblemGroup: globalProblemGroup.data, partnerProblemGroup: partnerProblemGroup.data }
})

export const getPGHistoryList = createAsyncThunk('CropHealthGlobal/getPGHistoryList', async (params) => {
    const response = await apiGetPGHistoryList(params)
    return { ...response.data, params };
})


export const initCropProblemTableData = {
    total: 0,
    page: 1,
    pageIndex: 1,
    pageSize: 5,
    loading: false,
    showTableData: [],
    filterTableData: [],
    query: '',
    sort: {
        order: '',
        key: ''
    }
}

const cropProblem = createSlice({
    name: 'CropProblem',
    initialState: {
        loading: false,
        cropProblemList: [],
        PGHistoryList:[],
        cropProblemTableData: initCropProblemTableData
    },
    reducers: {
        updatePageIndex: (state, action) => {
            state.cropProblemTableData.pageIndex = action.payload
        },
        updateQuery: (state, action) => {
            state.cropProblemTableData.query = action.payload;
        },
        updatePageSize: (state, action) => {
            state.cropProblemTableData.pageSize = action.payload
        },
        setCropProblemFilterSort: (state, action) => {
            state.cropProblemTableData.sort = action.payload;
        },
        updateCropProblemTable: (state, action) => {
            var serachValue = action.payload;
            state.cropProblemTableData.filterTableData = serachValue.slice(0, 5);
        },
        updateShowTableData: (state, action) => {
            state.cropProblemTableData.filterTableData = action.payload;
        },
        resetTableData: (state, action) => {
            state.cropProblemTableData = initCropProblemTableData
        },
        updateAllDataLength: (state, action) => {
            state.cropProblemTableData.total = action.payload;
        },
        updateFilterData: (state, action) => {
            state.cropProblemTableData.filterTableData = action.payload
        },

    },
    extraReducers: {

        [getProblemGroupsList.fulfilled]: (state, action) => {
            let globalProblemGroup = action?.payload?.globalProblemGroup?.data?.length ? action?.payload?.globalProblemGroup?.data : []
            let partnerProblemGroup = action?.payload?.partnerProblemGroup?.data?.length ? action?.payload?.partnerProblemGroup?.data : []

            let mergedArray = globalProblemGroup?.map(globObj => {
                let matchingPartObj = partnerProblemGroup?.find(partObj => partObj?.attributes?.problem_group?.data?.id === globObj?.id);
                
                if(matchingPartObj){
                    
                    let {attributes} = matchingPartObj;
                    let mergeObj = Object.assign({}, globObj.attributes, attributes, { draft_ChpProblemGroupId: matchingPartObj.id });
                
                   return {...globObj, attributes: mergeObj}
                }else{
                    return {...globObj, attributes: {...globObj.attributes, pgPublishedAt: null}}
                }
            });
            
            let list = mergedArray;
            state.cropProblemList = list;
            state.cropProblemTableData.loading = false;
            state.cropProblemTableData.total = list.length;
            state.cropProblemTableData.showTableData = list;
            const currentPageData = list.slice(0, 5);
            state.cropProblemTableData.filterTableData = currentPageData;
        },
        [getProblemGroupsList.rejected]: (state) => {
            state.cropProblemTableData.loading = false;
            state.cropProblemList = [];
        }, [getProblemGroupsList.pending]: (state) => {
            state.cropProblemTableData.loading = false;
            state.cropProblemList = [];
        },
        [getPGHistoryList.fulfilled]: (state, action) => {            
            let list = action.payload.data
            state.PGHistoryList = list
        },
        [getPGHistoryList.rejected]: (state) => {
            state.PGHistoryList = []
        },
        [getPGHistoryList.pending]: (state) => {
            state.PGHistoryList = []
        },
    }
})

export const {
    updatePageIndex,
    updateQuery,
    updatePageSize,
    setCropProblemFilterSort,
    updateCropProblemTable,
    updateShowTableData,
    resetTableData,
    updateAllDataLength,
    updateFilterData,

} = cropProblem.actions

export default cropProblem.reducer

export const publishProblemGroup = async (data, SuccessCallBack, ErrorCallBack) => {
    await apiPublishProblemGroup(data).then(({ status, data: { data, message } }) => {
        if (status && status === 200) {
            SuccessCallBack({ success: true, message: message, data: data })
        } else {
            ErrorCallBack({ success: false, message: message })
        }
    }).catch(({ message }) => { ErrorCallBack({ success: false, message: message }) })
}

export const checkProblemGroups = async (id,partnerId, SuccessCallBack, ErrorCallBack) => {
    await apiCheckProblemGroups(id,partnerId).then(({ status, data: { data, message } }) => {
        if (status && status === 200) {
            SuccessCallBack({ success: true, message: message, data: data })
        } else {
            ErrorCallBack({ success: false, message: message })
        }
    }).catch(({ message }) => { ErrorCallBack({ success: false, message: message }) })
}

export const createProblemGroups = async (data, SuccessCallBack, ErrorCallBack) => {
    await apiCreateProblemGroups(data).then(({ status, data: { data, message } }) => {
        if (status && status === 200) {
            SuccessCallBack({ success: true, message: message, data: data })
        } else {
            ErrorCallBack({ success: false, message: message })
        }
    }).catch(({ message }) => { ErrorCallBack({ success: false, message: message }) })
}

export const restorePGVersion = async (data, SuccessCallBack, ErrorCallBack) => {
    await apiRestorePGVersion(data).then(({ status, data: { data, message } }) => {
        if (status && status === 200) {
            SuccessCallBack({ success: true, message: message, data: data })
        } else {
            ErrorCallBack({ success: false, message: message })
        }
    }).catch(({ message }) => { ErrorCallBack({ success: false, message: message }) })
}
